import { createCrudActionSets, createNoPropsAction } from "../../../root-store/actions/action-creators";
import { ActionPayloadGeneric } from "../../../root-store/actions/index";
import { ServiceEvent } from "../../model/event-log";

/**
 * @description Used in the action creators to generate an action type like:
 * "[Activity Log] Load Activity"
 */
const actionCategory = "Activity Log";

type ActionPayload = ActionPayloadGeneric & {
    [index: string]: any;
};

interface LoadActionPayload {
    uuid: string;
    params: any[];
}

interface ActionResult {
    key: string;
    measurement_properties: ServiceEvent[];
    serverTimezone?: string;
}

export const {
    load: loadSet,
    create: createSet,
    update: updateSet,
    clear: clearSet,
} = createCrudActionSets<ActionPayload, LoadActionPayload, ActionResult, ActionResult>(actionCategory);

export const { request: load, success: loadSuccess, failure: loadFailure } = loadSet;

/**
 * An action to clear the data in the store
 */
export const clear = createNoPropsAction(actionCategory, "Clear State");
